module.exports = __webpack_public_path__ + "img/course-fairy.6e76e8d0.png";